import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  NativeSelect,
  TextField,
  Typography,
} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { Formik, FormikProps } from 'formik'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonGrid } from '../../components'
import { locale } from '../../locale'
import { getConcreteMonitorDevice } from '../../state/DeviceById/selectors'
import { deleteDevice, updateDeviceInfo } from '../../state/Firebase/operations'
import { editDeviceEnd } from '../../state/SystemCache/actions'
import { getUserAll } from '../../state/UserById/selectors'
import { Device, State, UpdateDeviceField, User } from '../../types'

const toj = JSON.stringify

type Props = {
  device?: Device
  users: User[]
  handleCancel: () => void
  handleDeleteDevice: (deviceId: string) => void
}

type Fields = UpdateDeviceField

function DeviceForm(props: Props) {
  const { device } = props

  if (!device) {
    return null
  }
  const fields: Fields = {
    label: device.info.label || '',
    memo: device.info.memo || '',
    token: device.info.token || '',
    currentUserId: device.currentUserId || 'none',
  }

  return (
    <div>
      <Formik
        initialValues={fields}
        validate={(_values) => {
          const errors: Partial<Fields> = {}
          // if (!values.name) {
          //   errors.name = 'Required'
          // }

          return errors
        }}
        onSubmit={(values: Fields) => {
          updateDeviceInfo(device.id, values)
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          setFieldTouched,
        }: FormikProps<Fields>) => {
          const change = (name, e) => {
            e.persist()
            handleChange(e)
            setFieldTouched(name, true, false)
          }

          console.log(touched.label)
          console.log(Boolean(errors.label))

          return (
            <form onSubmit={handleSubmit}>
              <Typography variant="h6">{device.id}</Typography>
              <TextField
                id="label"
                name="label"
                autoComplete="off"
                error={touched.label && Boolean(errors.label)}
                label={`${locale.device.label}(※クライアントも閲覧・編集可能なデータです。)`}
                helperText={touched.label ? errors.label : ''}
                value={values.label}
                onChange={change.bind(null, 'label')}
                fullWidth
              />
              <FormControl>
                <FormHelperText>
                  <InputLabel htmlFor="currentUserId">
                    {locale.device.clients}
                  </InputLabel>

                  <NativeSelect
                    id="currentUserId"
                    name="currentUserId"
                    error={
                      touched.currentUserId && Boolean(errors.currentUserId)
                    }
                    value={values.currentUserId}
                    onChange={change.bind(null, 'currentUserId')}
                  >
                    <option value="none">無し</option>
                    {props.users.map((user) => (
                      <option key={user.id} value={user.id}>
                        {user.label} - {user.email}
                      </option>
                    ))}
                  </NativeSelect>
                  {touched.currentUserId ? errors.currentUserId : ''}
                </FormHelperText>
              </FormControl>

              <TextField
                id="memo"
                name="memo"
                autoComplete="off"
                multiline
                error={touched.memo && Boolean(errors.memo)}
                label={locale.device.memo}
                helperText={touched.memo ? errors.memo : ''}
                value={values.memo}
                onChange={change.bind(null, 'memo')}
                fullWidth
              />
              <TextField
                id="token"
                name="token"
                disabled
                multiline
                error={touched.token && Boolean(errors.token)}
                label="token"
                value={values.token}
                onChange={change.bind(null, 'token')}
                fullWidth
              />
              <ButtonGrid>
                <Button onClick={() => props.handleCancel()}>キャンセル</Button>
                <Button
                  color="primary"
                  disabled={toj(fields) === toj(values)}
                  onClick={() => handleSubmit()}
                >
                  変更する
                </Button>
              </ButtonGrid>
              <Button
                fullWidth
                color="secondary"
                onClick={() => props.handleDeleteDevice(device.id)}
              >
                <DeleteIcon />
                {locale.deviceEntity}の削除
              </Button>
            </form>
          )
        }}
      </Formik>
    </div>
  )
}

type OProps = {
  deviceId: string
}
type SProps = {
  device?: Device
  users: User[]
}

const DeviceFormContainer = (op: OProps) => {
  const dispatch = useDispatch()
  const sp = useSelector<State, SProps>((state) => ({
    users: getUserAll(state),
    device: getConcreteMonitorDevice(state, op.deviceId),
  }))

  return (
    <DeviceForm
      {...sp}
      handleCancel={() => dispatch(editDeviceEnd())}
      handleDeleteDevice={(deviceId: string) =>
        dispatch(deleteDevice(deviceId))
      }
    />
  )
}

export default DeviceFormContainer
